import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaLinkedin, FaInstagram, FaArrowRight, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export default function Footer() {
  const nav = useNavigate();

  const goTo = (path) => {
    nav(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <svg className="footer-wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" preserveAspectRatio="none">
        <defs>
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style={{ stopColor: '#00d4ff', stopOpacity: 0.6 }} />
            <stop offset="50%" style={{ stopColor: '#7b2ff7', stopOpacity: 0.6 }} />
            <stop offset="100%" style={{ stopColor: '#ff006e', stopOpacity: 0.6 }} />
          </linearGradient>
        </defs>
        <path
          fill="url(#waveGradient)"
          d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
        >
          <animateTransform attributeName="transform" type="translate" from="0 0" to="1440 0" dur="20s" repeatCount="indefinite" />
        </path>
      </svg>

      <div className="footer-content">
        
        {/* Brand Section */}
        <div className="footer-section">
          <h4>Syntax2Scale</h4>
          <p className="footer-tagline">From Code To Commerce - We've Got You Covered</p>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/syntax2scale/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
            <a href="https://x.com/syntax2scale" target="_blank" rel="noreferrer"><FaXTwitter /></a>
            <a href="https://www.instagram.com/syntax2scale" target="_blank" rel="noreferrer"><FaInstagram /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>

          <a onClick={() => goTo('/')}>
            <FaArrowRight /> Home
          </a>

          <a onClick={() => goTo('/about')}>
            <FaArrowRight /> About
          </a>

          <a onClick={() => goTo('/services')}>
            <FaArrowRight /> Services
          </a>

          <a onClick={() => goTo('/projects')}>
            <FaArrowRight /> Projects
          </a>

          <a onClick={() => goTo('/contact')}>
            <FaArrowRight /> Contact
          </a>
        </div>

        {/* Contact Section */}
        <div className="footer-section">
          <h4>Contact</h4>
          <div className="footer-contact-item"><FaEnvelope /> <span>info@syntax2scale.com</span></div>
          <div className="footer-contact-item"><FaWhatsapp /> <span>+91 92747 66776</span></div>
          <div className="footer-contact-item"><FaMapMarkerAlt /> <span>Ahmedabad, India</span></div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Syntax2Scale. All rights reserved.</p>
      </div>
    </footer>
  );
}
